























import {Component, Prop, Vue} from 'vue-property-decorator'
import VueGallerySlideshow from 'vue-gallery-slideshow'
import {IImageSimple} from '@/entities'

@Component({
  components: {
    VueGallerySlideshow
  }
})
export default class TravelGallery extends Vue {
  @Prop({
    validator(value: any): boolean {
      return !!value.length;
    }
  }) readonly images!: IImageSimple[]

  private index: number | null = null

  get generalImage(): IImageSimple {
    return this.images[0];
  }

  get rowImages(): IImageSimple[] {
    return this.images.slice(1);
  }

}
